module.exports = __webpack_public_path__ + "img/株式会社政轩.832b0202.png";